// OTOMATİK ÜRETİLDİ — elle düzenlemeyin.
// Kaynak: package.json · Üreten: scripts/writeVersion.js
export const APP_VERSION = '1.1.0';
